// extracted by mini-css-extract-plugin
export default {"list":"z560lUm9zh"};